function applyListFilter(key, config) {
  const values = config.values || []
  if (values.length === 0) return

  const exactMatch = config.exact_match === 'on' || config.exact_match === true
  const checkbox = document.getElementById(`exact_match_checkbox_search[${key}]`)
  if (checkbox && checkbox.checked !== !!exactMatch) {
    checkbox.checked = !!exactMatch
    // The tick is drawn by Alpine, which only knows what it hears.
    checkbox.dispatchEvent(new Event('change', { bubbles: true }))
  }

  document.dispatchEvent(new CustomEvent('bulk-add-values', {
    detail: {
      values,
      exclusion: false,
      targetId: `main-input-search[${key}]`,
      restoration: true
    },
    bubbles: true
  }))
}

function applyRangeFilter(key, range) {
  ;['gte', 'lte'].forEach((bound) => {
    const val = range[bound]
    if (!val) return

    const input = document.querySelector(`input[name="search[${key}][${bound}]"]`)
    if (input) input.value = val
  })
}

function applyScalarFilter(key, value) {
  const input = document.querySelector(`input[name="search[${key}]"]`)
  if (!input) return

  if (input.type === 'checkbox') {
    input.checked = value === true || value === 'true' || value === '1' || value === 'on'
  } else {
    input.value = value
  }
}

export function applyLeadFinderSearchFilters(jsonFilters) {
  if (!jsonFilters || typeof jsonFilters !== 'object') return

  document.dispatchEvent(new CustomEvent('clear-filters', { bubbles: true }))

  Object.entries(jsonFilters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return

    if (typeof value === 'object' && !Array.isArray(value) && Object.prototype.hasOwnProperty.call(value, 'values')) {
      applyListFilter(key, value)
    } else if (typeof value === 'object' && !Array.isArray(value) && (value.gte || value.lte)) {
      applyRangeFilter(key, value)
    } else if (typeof value === 'string' || typeof value === 'boolean') {
      applyScalarFilter(key, value)
    }
  })
}
